module.exports = __webpack_public_path__ + "static/media/Alberta.5511eb82.svg";